// extracted by mini-css-extract-plugin
export default {"quantity_container":"kF","hiddenflavorstring":"lF","loadingLine":"mF","productimgwrap":"nF","productimg":"oF","circlepic":"pF","productinfo":"qF","grey_x":"rF","cartrow":"sF","bold":"tF","title":"uF","blue":"vF","strike":"wF","flexgap":"xF","flavorstring":"yF","nodecorate":"zF","flavorstring_link":"AF","rdstring":"BF","removeditemblock":"CF","removed_heading":"EF","removed_text":"FF","addback":"GF"};
    if(module.hot) {
      // 1726593106254
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  